<template>
  <div class="xcard">
    <p class="mb-0"> <b>Recuerda:</b> evita subir contactos duplicados para no llenar tu base de datos con contactos repetidos, si ya lo registraste anteriormente no lo subas de nuevo,
          si deseas actualizar alguna informacion de un contacto puedes usar la opcion de editarlo yendo a la lista de tus contactos.
    </p>
    <div class="row">
      <div class="col-sm-5"> 
        <input class="btn btn-sm" type="file" id="fileUpload" @change="Upload()"/>
      </div>
      <div v-show="false" class="col-sm-6">
        <input class="btn btn-sm btn-success green" type="button" id="upload" value="Visualizar datos" @click="Upload()" />
      </div>
    </div>
    <hr />

    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th>Nro</th>
            <th>errores</th>
            <th>Carnet</th>
            <th>Nombres</th>
            <th>Apellido 1</th>
            <th>Apellido 2</th>
            <th>Telefono</th>
            <th>Correo</th>
            <th>Fecha Visita</th>
            <th>Ciudad</th>
            <th>Estado</th>
            <th>Intereses</th>
            <th>Profesion</th>
            <th>Empresa</th>
            <th>Direccion</th>
            <th>Observacion</th>
            <th>Latitud</th>
            <th>Longitud</th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in contactos">
            <td> <small> {{ind+1}} </small> </td>
            <td> <small> {{e.msg}} </small> </td>
            <td> <small> {{e.numero_documento}} </small> </td>
            <td> <small> {{e.nombres}} </small> </td>
            <td> <small> {{e.primer_apellido}} </small> </td>
            <td> <small> {{e.segundo_apellido}} </small> </td>
            <td> <small> {{e.telefono}} </small> </td>
            <td> <small> {{e.correo}} </small> </td>
            <td> <small> {{e.fecha_visita}} </small> </td>
            <td> <small> {{e.ciudad}} </small> </td>
            <td> <small> {{e.estado}} </small> </td>
            <td> <small> {{mergetextintereses(e.intereses)}} </small> </td>
            <td> <small> {{e.profesion}} </small> </td>
            <td> <small> {{e.empresa}} </small> </td>
            <td> <small> {{e.direccion}} </small> </td>
            <td> <small> {{e.observacion}} </small> </td>
            <td> <small> {{e.latitud}} </small> </td>
            <td> <small> {{e.longitud}} </small> </td>
          </tr>
        </tbody>
      </table>

      <p class="text-center text-primary"> {{msg}} </p>
      <button v-if="contactos.length>0" :disabled="subiendo" class="btn btn-sm btn-azul" @click="subir()"> Subir contactos </button>
    </div>

    <div id="dvExcel">
    </div>
  </div>
</template>

/* <style>
.table th,.table td{
    white-space: nowrap;
}
</style> */

<script>
//import gql from 'graphql-tag'
//import {parseJsonError} from '@/components/Utils.js'
import {getheadersrest} from '@/components/Utils';

export default {
  data(){
    return{
      modeldatos: {xtitle:'',xbody:'',xsql:''},
      subiendo: false,
      contactos:[],
      msg:'',
    }
  },
  components:{ },
  methods:{
    Upload() {
      var vue = this;
        var fileUpload = document.getElementById("fileUpload");
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) { vue.processExcel(e.target.result); };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) { data += String.fromCharCode(bytes[i]); }
                        vue.processExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Por favor seleccione un archivo excel valido.");
        }
    },
    processExcel(data) {
        var vue = this;
        var workbook = window.XLSX.read(data, { type: 'binary',cellText:false,cellDates:true });
 
        var firstSheet = workbook.SheetNames[0];
        var excelRows = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet],{dateNF:'dd/mm/yyyy'});

        window.console.log( 'EXCEL ROW: ',excelRows );
        let idasesor = this.$store.state.DATA_USER.id;
        if( !idasesor ){
          this.msg = 'Id asesor no seleccionado, intente salir y volver a ingresar.';
          return;
        } 
        excelRows.forEach( function(e,index){
            if( index > 2 ) {
                let carnet = e['__EMPTY'];
                let nombres = e['__EMPTY_1'];
                let ap1 = e['__EMPTY_2'];
                let ap2 = e['__EMPTY_3'];
                let telefono = e['__EMPTY_4'];
                let correo = e['__EMPTY_5'];
                let fechavisita = e['__EMPTY_6'];
                let ciudad = e['__EMPTY_7'];
                let estado = e['__EMPTY_8'];
                let intereses = e['__EMPTY_9'];
                let profesion = e['__EMPTY_10'];
                let empresa = e['__EMPTY_11'];
                let direccion = e['__EMPTY_12'];
                let observacion = e['__EMPTY_13'];
                let latitud = e['__EMPTY_14'];
                let longitud = e['__EMPTY_15'];

                let contacto = {
                    numero_documento: vue.xtrim(carnet),
                    nombres: vue.xtrim(nombres),
                    primer_apellido: vue.xtrim(ap1),
                    segundo_apellido: vue.xtrim(ap2),
                    telefono: vue.xtrim(telefono),
                    correo: vue.xtrim(correo),
                    empresa: vue.xtrim(empresa),
                    profesion: vue.xtrim(profesion),
                    asesor_id: idasesor,
                    fecha_visita: vue.xtrim(fechavisita),
                    estado: vue.xtrim(estado),
                    latitud: vue.xtrim(latitud),
                    longitud: vue.xtrim(longitud),
                    ciudad: vue.xtrim(ciudad),
                    direccion: vue.xtrim(direccion),
                    observacion: vue.xtrim(observacion),
                    intereses: vue.xtrim(intereses),
                }
                vue.validardatos( contacto );
            
                vue.contactos.push( contacto );
                //window.console.log( '-- ',contacto );
            }
        });

    },
    xtrim( v ){
        if( v && typeof(v) == 'string' ) return v.trim();
        return v;
    },
    validardatos( contacto ){
        //window.console.log( contacto );
        if( contacto.numero_documento && contacto.numero_documento.length > 30 ) contacto.msg = 'Carnet no valido';
        else if( !contacto.nombres || contacto.nombres.length > 30 ) contacto.msg += 'Nombres no valido. ';
        else if( !contacto.primer_apellido || contacto.primer_apellido.length > 25 ) contacto.msg += 'Apellido1 no valido. ';
        else if( contacto.segundo_apellido && contacto.segundo_apellido.length > 25 ) contacto.msg += 'Apellido2 no valido. ';
        else if( !contacto.telefono || contacto.telefono.length > 20 ) contacto.msg += 'Telefono no valido. ';
        else if( contacto.correo && contacto.correo.length > 100 ) contacto.msg += 'Correo no valido. ';
        else if( contacto.empresa && contacto.empresa.length > 100 ) contacto.msg += 'Empresa no valido. ';
        else if( contacto.profesion && contacto.profesion.length > 100 ) contacto.msg += 'Carnet no valido. ';
        else if( !contacto.asesor_id ) contacto.msg += 'Algo salio mal, intenta volver a ingresar a esta pantalla y carga el archivo. ';
        else if( !contacto.fecha_visita || !/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(contacto.fecha_visita) ) contacto.msg += 'Formato de fecha no valido. ';
        else if( !contacto.estado || contacto.estado.length > 50 ) contacto.msg += 'Estado no valido. ';
        else if( !contacto.ciudad || contacto.ciudad.length > 100 ) contacto.msg += 'Ciudad no valido. ';
        else if( contacto.direccion && contacto.direccion.length > 100 ) contacto.msg += 'Direccion no valido. ';
        else if( contacto.observacion && contacto.observacion.length > 100 ) contacto.msg += 'Observacion no valido. ';
        else if( !contacto.intereses || contacto.intereses.length == 0 ) contacto.msg += 'Escriba al menos 1 interes. ';
        this.splitintereses( contacto );
    },
    splitintereses( contacto ){
      if( !contacto.intereses ) {
        contacto.intereses = [];
        return
      }
        const partes = contacto.intereses.split(',');
        const ints = [];
        partes.forEach( function(e){
            let interes = e.trim();
            if( interes.length > 150 ) contacto.msg +="Interes no valido";
            ints.push( {nombre:interes} );
        });
        contacto.intereses = ints;
    },
    mergetextintereses( intereses ){
        var txt = '';
        intereses.forEach(function(e){
            txt += e.nombre+', ';
        })
        if( txt.length > 0 ){ txt = txt.substring(0,txt.length-2)}

        return txt;
    },
    parseFecha( est ){
      try{
        var fe = est.fecha_visita.split('-');
        est.fecha_visita = fe[2]+'-'+fe[1]+'-'+fe[0];
        return true;
      } catch{
        est.estado = 'FECHA INVALIDA: DD-MM-YYYY';
        return false;
      }
    },
    async subir(){
        //var myHeaders = new Headers();
        let myHeaders = getheadersrest();
        myHeaders.append("Content-Type", "application/json");
        const xcontactos = [];
        this.contactos.forEach(function(e){
            delete e.msg;
            xcontactos.push( e );
        });

        var raw = JSON.stringify( xcontactos );
        const vue = this;
        this.msg = 'Subiendo contactos...';
        //window.console.log( raw );

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
        };

        fetch(process.env.VUE_APP_API_REST+'/api/esam/contactos', requestOptions)
        .then(response => response.json())
        .then(result => {
            window.console.log(result)
            if( result.result ){
                vue.contactos = [];
                vue.msg = 'Contactos subidos correctamente.'
            }else{
                var txt = '';
                result.errors.forEach(function(e){
                    txt += e+'\n';
                })
                vue.msg = txt;
            }
        })
        .catch(error => window.console.log('error', error));
    },
  },

  mounted(){

  }
}
</script>